__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@veeva-oncology-link/ui-shell";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("./src/components", "0", () => (Promise.all([__webpack_require__.e(679), __webpack_require__.e(4623), __webpack_require__.e(5064), __webpack_require__.e(4037), __webpack_require__.e(5805), __webpack_require__.e(154), __webpack_require__.e(4914), __webpack_require__.e(4188), __webpack_require__.e(632), __webpack_require__.e(6672), __webpack_require__.e(1985), __webpack_require__.e(7705), __webpack_require__.e(7827), __webpack_require__.e(5168)]).then(() => (() => (__webpack_require__(47026))))));
			register("./src/hooks", "0", () => (Promise.all([__webpack_require__.e(5064), __webpack_require__.e(4914), __webpack_require__.e(4188), __webpack_require__.e(632), __webpack_require__.e(2784)]).then(() => (() => (__webpack_require__(52784))))));
			register("@apollo/client", "3.13.5", () => (Promise.all([__webpack_require__.e(1925), __webpack_require__.e(9175), __webpack_require__.e(8559), __webpack_require__.e(4914)]).then(() => (() => (__webpack_require__(48559))))));
			register("@emotion/react", "11.14.0", () => (Promise.all([__webpack_require__.e(679), __webpack_require__.e(4914), __webpack_require__.e(4158)]).then(() => (() => (__webpack_require__(54158))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(4914)]).then(() => (() => (__webpack_require__(40961))))));
			register("react-i18next", "15.4.0", () => (Promise.all([__webpack_require__.e(2389), __webpack_require__.e(4914)]).then(() => (() => (__webpack_require__(32389))))));
			register("react-jss", "10.10.0", () => (Promise.all([__webpack_require__.e(7314), __webpack_require__.e(4914), __webpack_require__.e(8168)]).then(() => (() => (__webpack_require__(37735))))));
			register("react-redux", "7.2.9", () => (Promise.all([__webpack_require__.e(1225), __webpack_require__.e(4914), __webpack_require__.e(6672)]).then(() => (() => (__webpack_require__(61225))))));
			register("react-router-dom", "5.3.4", () => (Promise.all([__webpack_require__.e(7929), __webpack_require__.e(3924), __webpack_require__.e(4914)]).then(() => (() => (__webpack_require__(53924))))));
			register("react", "18.2.0", () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))));
			initExternal(21541);
			initExternal(96434);
			initExternal(23671);
			initExternal(41883);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};